// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"517fd6af","82":"83654e42","453":"b1c6d853","463":"a8dee813","613":"1288dccf","707":"5acf7283","748":"e118387f"}[chunkId] + ".chunk.js";
};